/*
 * @Author: edvardchen
 * @Date: 2017-12-08 19:50:25
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-08-18 16:59:52
 */

// @flow
// inspired by react-router
import * as React from 'react';
import _ from 'lodash';

type S = {
  mod?: ?React.Component<*>,
};
/* eslint-disable react/no-unused-prop-types */
export type Props = {
  load: Function,
  children: Function,
  chips?: Object,
};

class Bundle extends React.Component<Props, S> {
  state = {};

  componentDidMount() {
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(nextProps.load.toString(), this.props.load.toString())) {
      this.load(nextProps);
    }
  }

  async load(props: Props) {
    this.setState({
      mod: null,
    });
    const { chips } = props;
    const mod = chips ? (await props.load())[chips] : await props.load();
    this.setState({
      mod: mod.default ? mod.default : mod,
    });
  }

  render() {
    const { mod } = this.state;
    return mod ? this.props.children(mod) : null;
  }
}

export default Bundle;
